import React, { useCallback } from 'react';
import { ITreeNode } from 'components/Tree/CommonTree/CommonTreeNode';
import { IWorkflowCatalogNode } from './WorkflowCatalogUtils';
import { Tree } from 'components/Tree/CommonTree/Tree';
import { createEvent } from 'utils/DomUtils';
import { isRightButtonPressed } from 'utils/KeyBoardUtils';
import { WorkflowCatalogNode } from './WorkflowCatalogNode';
import { getWorkflowCatalogPanelRootNodes, usePortalStore } from 'domains/portal/PortalStore';
import { NoWorkflowsMessage } from './NoWorkflowsMessage';
import { useWorkflowTreeStore } from './hooks/useWorkflowTreeStore';

export interface IWorkFlowCatalogProps {
  treeId?: string;
  showContextMenu: (node: IWorkflowCatalogNode, element: HTMLElement) => void;
}

export function WorkflowCatalogTree({ treeId, showContextMenu }: IWorkFlowCatalogProps) {
  const rootNodes = usePortalStore(getWorkflowCatalogPanelRootNodes);

  const resizeLeftPanel = useCallback(() => {
    window.dispatchEvent(createEvent('resizeLeftPanel'));
  }, []);

  const onMouseDown = useCallback(
    (node: ITreeNode<IWorkflowCatalogNode>, e: React.MouseEvent) => {
      if (node.data && e.nativeEvent.target && isRightButtonPressed(e)) {
        // currentTarget should be the node, not one of its children.
        showContextMenu(node.data, e.currentTarget as HTMLElement);
      }
    },
    [showContextMenu]
  );

  const { nodes, isLoading, selectNode, foldNode, expandNode } = useWorkflowTreeStore({
    treeId,
    rootNodes,
    onNodeExpanded: resizeLeftPanel,
    onNodeFolded: resizeLeftPanel,
  });

  return !!nodes?.length || isLoading ? (
    <Tree
      classes={{
        root: 'dp-workflow-tree',
      }}
      nodes={nodes}
      onNodeMouseDown={onMouseDown}
      onNodeExpand={expandNode}
      onNodeFold={foldNode}
      onNodeSelect={selectNode}
      nodeContentComponent={WorkflowCatalogNode}
      loading={{
        isLoading,
        height: 300,
      }}
    />
  ) : (
    <NoWorkflowsMessage />
  );
}
